import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.16663 3.33366C3.66663 3.33366 3.33329 3.66699 3.33329 4.16699V9.16699C3.33329 9.66699 2.99996 10.0003 2.49996 10.0003C1.99996 10.0003 1.66663 9.66699 1.66663 9.16699V4.16699C1.66663 2.75033 2.74996 1.66699 4.16663 1.66699H15.8333C17.25 1.66699 18.3333 2.75033 18.3333 4.16699V9.16699C18.3333 9.66699 18 10.0003 17.5 10.0003C17 10.0003 16.6666 9.66699 16.6666 9.16699V4.16699C16.6666 3.66699 16.3333 3.33366 15.8333 3.33366H12.5V5.83366C12.5 6.33366 12.1666 6.66699 11.6666 6.66699H8.33329C7.83329 6.66699 7.49996 6.33366 7.49996 5.83366V3.33366H4.16663ZM10.8333 5.00033H9.16663V3.33366H10.8333V5.00033Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.49996 16.667C2.49996 17.167 2.83329 17.5003 3.33329 17.5003H4.99996C6.41663 17.5003 7.49996 16.417 7.49996 15.0003V13.3337C7.49996 11.917 6.41663 10.8337 4.99996 10.8337H3.33329C2.83329 10.8337 2.49996 11.167 2.49996 11.667V16.667ZM4.99996 15.8337H4.16663V12.5003H4.99996C5.49996 12.5003 5.83329 12.8337 5.83329 13.3337V15.0003C5.83329 15.5003 5.49996 15.8337 4.99996 15.8337Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M11.6666 17.5003H9.16663C8.66663 17.5003 8.33329 17.167 8.33329 16.667V11.667C8.33329 11.167 8.66663 10.8337 9.16663 10.8337H11.6666C12.1666 10.8337 12.5 11.167 12.5 11.667C12.5 12.167 12.1666 12.5003 11.6666 12.5003H9.99996V13.3337H11.6666C12.1666 13.3337 12.5 13.667 12.5 14.167C12.5 14.667 12.1666 15.0003 11.6666 15.0003H9.99996V15.8337H11.6666C12.1666 15.8337 12.5 16.167 12.5 16.667C12.5 17.167 12.1666 17.5003 11.6666 17.5003Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M15.9166 17.0003C16.0833 17.3337 16.3333 17.5003 16.6666 17.5003C16.8333 17.5003 16.9166 17.5003 17.0833 17.417C17.4166 17.2503 17.5833 16.7503 17.4166 16.3337L16.3333 14.167L17.4166 11.917C17.5 11.8337 17.5 11.7503 17.5 11.5837C17.5 11.2503 17.3333 11.0003 17 10.8337C16.5833 10.5837 16.0833 10.7503 15.9166 11.167L15.4166 12.167L14.9166 11.167C14.75 10.8337 14.25 10.667 13.8333 10.8337C13.5 11.0003 13.3333 11.5003 13.5 11.917L14.5833 14.0837L13.5 16.2503C13.25 16.667 13.4166 17.167 13.8333 17.3337C14.25 17.5837 14.75 17.417 14.9166 17.0003L15.4166 16.0003L15.9166 17.0003Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}